import { useState } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Calendar } from "../../ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "../../ui/popover";
import { isLocalCity } from "../../../lib/pricing";
import { formatMXN } from "../../../lib/whatsapp";

const CALENDAR_CLASS_NAMES = {
  caption_label: "text-sm font-medium text-white",
  head_cell: "text-white/40 rounded-md w-8 font-normal text-[0.8rem]",
  day: "h-8 w-8 p-0 font-normal text-white/80 hover:bg-twp-gold/20 hover:text-white rounded-md aria-selected:opacity-100",
  day_selected: "bg-twp-gold text-black hover:bg-twp-gold hover:text-black focus:bg-twp-gold focus:text-black",
  day_today: "bg-white/10 text-white",
  day_outside: "text-white/20",
  day_disabled: "text-white/10",
  nav_button: "h-7 w-7 bg-transparent p-0 text-white/60 hover:text-white hover:bg-white/10 rounded-md",
};

const isPastDate = (date) => date < new Date(new Date().setHours(0, 0, 0, 0));

export const EventStep = ({ form, update, matchedTravelCost }) => {
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  return (
    <div className="space-y-6">
      <h3 className="font-serif-display text-2xl text-white mb-2">Detalles del evento</h3>
      <div>
        <Label className="text-white/60 text-xs uppercase tracking-wider">Fecha tentativa</Label>
        <Popover open={datePickerOpen} onOpenChange={setDatePickerOpen}>
          <PopoverTrigger asChild>
            <button
              type="button"
              data-testid="quote-input-date"
              className="w-full flex items-center justify-between gap-2 bg-black border border-white/20 text-white mt-2 rounded-md px-3 py-2 text-sm hover:border-twp-gold/50 transition-colors"
            >
              <span className={form.event_date ? "text-white" : "text-white/40"}>
                {form.event_date
                  ? format(new Date(`${form.event_date}T00:00:00`), "d 'de' MMMM 'de' yyyy", { locale: es })
                  : "Selecciona una fecha"}
              </span>
              <CalendarIcon size={16} className="text-twp-gold" />
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0 bg-twp-charcoal border-white/10" align="start">
            <Calendar
              mode="single"
              selected={form.event_date ? new Date(`${form.event_date}T00:00:00`) : undefined}
              onSelect={(date) => {
                if (date) update("event_date", format(date, "yyyy-MM-dd"));
                setDatePickerOpen(false);
              }}
              disabled={isPastDate}
              initialFocus
              locale={es}
              data-testid="quote-calendar-picker"
              classNames={CALENDAR_CLASS_NAMES}
            />
          </PopoverContent>
        </Popover>
      </div>
      <div>
        <Label className="text-white/60 text-xs uppercase tracking-wider">Ciudad</Label>
        <Input
          data-testid="quote-input-city"
          value={form.city}
          onChange={(e) => update("city", e.target.value)}
          className="bg-black border-white/20 text-white mt-2"
          placeholder="Ingresa la ciudad"
        />
        {form.city.trim() && !isLocalCity(form.city) && (
          matchedTravelCost ? (
            <p data-testid="quote-travel-cost-match" className="text-twp-gold text-xs mt-2">
              + Viáticos a {matchedTravelCost.city}: {formatMXN(matchedTravelCost.price)} (se agregan al total)
            </p>
          ) : (
            <p data-testid="quote-travel-cost-no-match" className="text-white/40 text-xs mt-2 italic">
              El costo de viáticos para esta ciudad se cotizará por separado.
            </p>
          )
        )}
      </div>
    </div>
  );
};
